'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import Loading from '@/app/loading';
// biome-ignore lint/suspicious/noShadowRestrictedNames: Map is the name of our own map component; renaming would require updating all usages
import Map from '@/components/maps/Map';
import ApiResponseErrorDisplay from '@/components/util/ApiResponseErrorDisplay';
import { useFindByLocationQuery } from '@/lib/api';
import type { ZorgbaseSearchResult } from '@/lib/services/ZorgbaseSearchService';
import FormPostcode, { ShowOptions } from './FormPostcode';

export interface ZorgZoekerProps {
	query?: string;
	initialData?: ZorgbaseSearchResult | null;
}

export default function ZorgZoeker({ query, initialData }: ZorgZoekerProps) {
	const baseQuery = decodeURIComponent(query ? query.replace(/\+/g, '%20') : '');
	const [currentQuery, setCurrentQuery] = useState(baseQuery);
	const t = useTranslations();
	const [show, setShow] = useState<ShowOptions>(ShowOptions.all);
	const [displayMap, setDisplayMap] = useState(false);

	// Skip RTK Query when we have server-provided initialData for the current query
	const hasInitialData = !!initialData && currentQuery === baseQuery;
	const {
		data: clientData,
		error,
		isLoading,
		isError,
	} = useFindByLocationQuery(currentQuery, {
		skip: !currentQuery || hasInitialData,
	});

	const data = hasInitialData ? initialData : clientData;

	return (
		<>
			<div className="card-form">
				<h1>{t('Generic.HuisartsZoeker')}</h1>
				<FormPostcode
					query={currentQuery}
					setQuery={setCurrentQuery}
					show={show}
					setShow={setShow}
					displayMap={displayMap}
					setDisplayMap={setDisplayMap}
				/>
			</div>
			<div className="container">
				{isLoading && !data && <Loading />}
				{isError && !hasInitialData && <ApiResponseErrorDisplay title={t('Generic.no-results')} error={error} />}
				{data && (
					<Map
						organisations={data.results}
						location={{ lat: data.location.lat, lng: data.location.lon }}
						type={show}
						displayMap={displayMap}
					/>
				)}
			</div>
		</>
	);
}
